
import { CUSTOMER_STATUS_URL } from "./endpoints";
import getRetailTokenClient from "@utils/getRetailToken.client";

export type CustomerStatus = {
  is_active_policy_holder: boolean;
  is_acko_customer: boolean;
};

/**
 * Fetch customer status from API
 */
export async function fetchCustomerStatus(): Promise<CustomerStatus | null> {
  try {
    const url = CUSTOMER_STATUS_URL;
    const retailToken = await getRetailTokenClient();
    
    const headers: Record<string, string> = {
      "Accept": "application/json",
    };

    if (retailToken) {
      headers["RetailToken"] = retailToken;
    }

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.info("Fetched customer status from API:", data);
    return data;
  } catch (error) {
    console.error("Error fetching customer status", error instanceof Error ? error.message : "Unknown error");
    return null;
  }
} 